/** Shared decoration / food messaging (expand later for Add-ons page) */

export const decorationsContentDefaults = {
  highlightsNote:
    "+ ₹349/extra person (50% discount for kids below 10yrs)",
  coupleOfferLine: "Perfect for couples & small groups",
};
